import { useBotConversation } from '../shared/BotConversationContext';
import type { SuggestedMessage } from '../shared/chatbot.types';
import { ChatHistory } from './ChatHistory';
import { Conversation } from './Conversation';
import { ChatBody } from './layout/ChatBody';
import { ChatFooter } from './layout/ChatFooter';
import { InputField } from './layout/InputField';

interface ChatBoxProps {
  suggestions?: SuggestedMessage[];
}

export default function ChatBox({ suggestions }: ChatBoxProps) {
  const { panelDisplayed } = useBotConversation();

  if (panelDisplayed === 'history') {
    return <ChatHistory />;
  }

  return (
    <>
      <ChatBody>
        <div className="sgwt-chatbot-messages flex-grow-1 d-flex flex-column">
          <div className="flex-grow-1 d-flex flex-column-reverse overflow-auto">
            <Conversation suggestions={suggestions} />
          </div>
        </div>
      </ChatBody>
      <ChatFooter>
        <InputField />
      </ChatFooter>
    </>
  );
}
